/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { STATES } from 'cio/models/delivery';
import { isDeliveryMeasureEnabledForChannel } from 'cio/utils/metrics/measure';
import { Channel, Measure } from 'cio/utils/metrics/common';

interface StatusPopoverArgs {
  actionType: Channel;
}

export default class StatusPopover extends Component<StatusPopoverArgs> {
  get states() {
    return [...STATES]
      .reverse()
      .filter((state) => isDeliveryMeasureEnabledForChannel(state as Measure, this.args.actionType));
  }
}
